import { Context } from 'unleash-client';
import { z } from 'zod';

export const unleashContextProperties = z.object({
  os: z.string(),
  appVersion: z.string(),
  appName: z.string(),
  country: z.string(),
  activeSubscriptionProduct: z.string(),
  hasActiveSubscription: z.string(),
  language: z.string(),
  subscriptionTestVariant: z.string(),
  userAgeInDays: z.string(),
  userCreationDate_YYYYMMDDhhmmss: z.string(),
  daysSinceLastPointsPurchase: z.string(),
  totalPointsPurchased: z.string(),
  daysSinceSubscriptionExpiration: z.string(),
  latestUnlimitedSubscriptionProductId: z.string(),
  countdownUniqueImpressionsCount: z.string(),
  marketingSegmentId: z.string(),
  activeRevcatContentEntitlement: z.string(),
  userSubscriptionExpirationDate_YYYYMMDDhhmmss: z.string(),
  daysSinceLatestUnsubscription: z.string(),
  userUnsubscribeDate_YYYYMMDDhhmmss: z.string(),
  willActiveUnlimitedSubscriptionRenew: z.string(),
  hasActiveUnlimitedEntitlement: z.union([z.literal('true'), z.literal('false')]).optional(),
  activeUnlimitedEntitlementSources: z.string(),
  latestStripeSubscriptionSku: z.string(),
  /** Hours since install, for featureGoldenHour targeting */
  userAgeInHours: z.string().optional(),
  /** Chapters read (first hour), for featureGoldenHour targeting */
  chaptersRead: z.string().optional(),
  /** Paywall layer buckets, 0 to 99, hashed from the uid; see libs/utils-unleash layerBuckets */
  paywallDomain: z.string().optional(),
  offerBucket: z.string().optional(),
  paywallUiBucket: z.string().optional(),
  /** Universal recommendations holdout layer, 0 to 99 (0 to 9 held out), hashed from the uid by `recsBucket` in libs/utils-unleash. Set by the Galatea app and galatea-web for signed-in users; Saturn does not send it. */
  recsGalatea26: z.string().optional(),
});

export type UnleashContextProperties = z.infer<typeof unleashContextProperties>;

export type UnleashContext = Context & {
  userId: string;
  // NOTE: Unleash Context value should never be `boolean`. It only accepts string and number
  properties: Partial<UnleashContextProperties>;
};
